import { NQError } from "@visonum/network-quality-sdk";
import createKey from "./createKey";
import errorCodeToString from "./errorCodeToString";
import getCauseTags from "./getCauseTags";
import SentryTags from "../../features/sentryReports/SentryTags";

export const getTagsForNqError = (error: NQError, prefix: string | null): SentryTags => {
    const result: SentryTags = {};
    result[createKey("ErrorCode", prefix)] = errorCodeToString(error.code);
    if (error.cause !== null) {
        const causeTags = getCauseTags(error.cause, createKey("ErrorCause", prefix));
        Object.keys(causeTags).forEach(key => {
            result[key] = causeTags[key];
        });
    }

    return result;
}

export default getTagsForNqError;